// @otto/api: every route contract between the browser, otto-app and
// otto-live. Changing anything here is a contract change.
import type { RouteContract } from "./common";
import { adminRoutes } from "./admin";
import { brainRoutes } from "./brain";
import { publicRoutes } from "./public";

export * from "./common";
export * from "./public";
export * from "./admin";
export * from "./brain";
export * from "./live-rpc";

/** Every otto-app route, for tests and for listing. */
export const allRoutes: Record<string, RouteContract> = {
  ...publicRoutes,
  ...adminRoutes,
  ...brainRoutes,
};
